// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAHT5LL-hEJOn2V8zOrD0heQT7jlFBgQ_k",
    authDomain: "bldiamond-6fda8.firebaseapp.com",
    databaseURL: "https://bldiamond-6fda8.firebaseio.com",
    projectId: "bldiamond-6fda8",
    storageBucket: "bldiamond-6fda8.appspot.com",
    messagingSenderId: "314694036509"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
